import {
  ApiReportReportTypeChoices,
  ApiReportSectionsAiGeneratedStatusChoices,
  ReportSectionsType,
} from "@api/graphql/types-and-hooks";
import {
  useIsReportBaseTemplate,
  useIsReportCompleted,
  useIsReportHandlebars,
  useIsReviewPage,
} from "@components/ReportField/capabilities/flags";
import { APPENDIX_PAGE_LOCATION, RECOMMENDATIONS_PAGE_LOCATION } from "@components/ReportField/consts";
import { useReport } from "@providers/ReportProvider";

// Whether the "add content" affordance shows below a field. Reproduces the legacy
// SectionWidgetWrapper `canAddContent` per surface (inline-edit treated as off).
export const useCanAddContent = (section: ReportSectionsType): boolean => {
  const { report, viewMode } = useReport();
  const isReviewPage = useIsReviewPage();
  const isCompleted = useIsReportCompleted();
  const isHandlebars = useIsReportHandlebars();
  const isBaseTemplate = useIsReportBaseTemplate();

  if (isCompleted) return false;
  if (isReviewPage) return false;

  const reportType = report.reportType;
  const onAppendix = section.pageLocation === APPENDIX_PAGE_LOCATION;
  const onRecommendations = section.pageLocation === RECOMMENDATIONS_PAGE_LOCATION;
  const sectionStillGenerating =
    section.aiGeneratedStatus === ApiReportSectionsAiGeneratedStatusChoices.SectionPredictionPending;

  if (sectionStillGenerating) return false;

  if (reportType === ApiReportReportTypeChoices.InitialAssessment) {
    return isHandlebars;
  }
  if (reportType === ApiReportReportTypeChoices.DiagnosisEvaluation && viewMode === "step") {
    if (onRecommendations) return false;
    return isBaseTemplate || onAppendix;
  }

  // clinical
  return isHandlebars;
};
